export default "__VITE_ASSET__cff3af8d__"